module.exports = __webpack_public_path__ + "img/low-interest.803773bf.png";